import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93f2da10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header",
  id: "header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-menu" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "header__nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__hide" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-menu" })
], -1))
const _hoisted_7 = { class: "aside-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "MENU", -1))
const _hoisted_9 = { class: "aside-nav" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aside-gnb" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dim = _resolveComponent("Dim")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass($props.isDark ? 'dark' : null)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "header__menu",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isMenuOpen = true))
        }, _hoisted_3),
        _createElementVNode("button", {
          class: _normalizeClass(["header__gnb", $props.gnbShow ? null : 'hide']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
        }, null, 2),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuArr, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["header__nav__li", 
						_ctx.$router.currentRoute.value.path.includes(
							item.path
						)
							? 'active'
							: null
					]),
              key: item.i,
              onClick: ($event: any) => (_ctx.$router.push(item.path))
            }, _toDisplayString(item.title), 11, _hoisted_5))
          }), 128))
        ]),
        _hoisted_6
      ])
    ], 2),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.isMenuOpen)
          ? (_openBlock(), _createBlock(_component_Dim, {
              key: 0,
              onOnClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isMenuOpen = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("aside", {
      class: _normalizeClass([
			$setup.isMenuOpen ? 'open' : null,
			$props.isDark ? 'dark' : null,
		])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("i", {
          class: "icon-close",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isMenuOpen = false))
        })
      ]),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuArr, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["aside-nav__li", 
					_ctx.$router.currentRoute.value.path.includes(
						item.path
					)
						? 'active'
						: null
				]),
            key: item.i,
            onClick: ($event: any) => (_ctx.$router.push(item.path))
          }, _toDisplayString(item.title), 11, _hoisted_10))
        }), 128))
      ]),
      _hoisted_11
    ], 2)
  ], 64))
}